"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoTransformProvider = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 */
class NoTransformProvider {
    constructor() {
        this.groupId = rc_js_util_1._Identifier.getNextIncrementingId();
        this.transformComponent = null;
        this.bufferLayoutProvider = null;
    }
    getTransformBinder() {
        return null;
    }
    updateTransform() {
        // no action needed
    }
    setOutputBuffers() {
        // no action needed
    }
    setGroupId(_groupId) {
        // change is not permissible
    }
    isTransformRequired() {
        return false;
    }
}
exports.NoTransformProvider = NoTransformProvider;
//# sourceMappingURL=no-transform-provider.js.map